import React, { Component, Fragment } from 'react'
import MetaTags from 'react-meta-tags'
import Header from '../layouts/Headerinner'
import Footer from '../layouts/Footer'

const pagelocation = 'Condition générales de vente'

const restaurant = JSON.parse(localStorage.getItem('restaurant'))
const application = JSON.parse(localStorage.getItem('application'))

class CGV extends Component {
	render() {
		return (
			<Fragment>
				<MetaTags>
					<title>
						{restaurant.name} | {pagelocation}
					</title>
					<meta name='description' content='#' />
				</MetaTags>
				<Header />
				{/* <Breadcrumbs breadcrumb={{ pagename: pagelocation }} /> */}
				<div className='section'>
					<div className='container'>
						<div className='post-content'>
							<h2>Conditions Générales de Ventes</h2>
							<p>
								Le service de Click & Collect permettant la commande en ligne de produits disponibles dans le restaurant
								{restaurant.name} et accessible via le site www.{application.webDomain}.drive-eat.fr
								<br />
								Les présentes Conditions Générales de Vente (ci-après les « CGV ») s'appliquent à toute commande (ci-après « Commande
								») d'un ou plusieurs produits (ci-après le ou les « Produit(s) ») passée par l'acheteur (ci-après le « Client ») sur
								le site marchand www.{application.webDomain}.drive-eat.fr (ci-après le "Site "). Le Click & Collect sur le Site, est
								réservé aux Clients âgés d'au moins 15 ans à la date de passation de la commande. Les présentes CGV prévaudront sur
								toutes autres conditions générales ou particulières non expressément agréées par le Vendeur. Le Vendeur se réserve le
								droit de modifier les CGV à tout moment. Dans tous les cas, les CGV applicables seront celles figurant sur le Site à
								la date de la Commande par le Client.
							</p>
							<p></p>
							<h3>Acceptation des CGV</h3>
							<p>
								Le Client déclare avoir pris connaissance et accepté les présentes CGV avant la passation de sa Commande. Toute
								Commande d'un Produit sur le Site matérialise donc de la part du Client l'acceptation des présentes CGV.
							</p>
							<h3>Les produits</h3>
							<p>
								Les produits proposés par le Restaurant, choisis par le Client sont ceux qui figurent dans le catalogue publié sur le
								Site le jour de la Commande, dans la limite toutefois des stocks disponibles. Il est recommandé de consommer
								rapidement les produits à compter de leur retrait en Restaurant ou de leur Livraison et de ne jamais les congeler. Les
								produits présentés à la vente sont susceptibles d'être modifiés ou supprimés par le Vendeur sans aucun préavis.
							</p>
							<h3>Passation des Commandes Click & Collect</h3>
							<p>
								Pour commander en ligne et retirer sa Commande en Restaurant le Client devra :
								<br />- se rendre sur le Site,
								<br />- effectuer sa Commande en sélectionnant les Produits,
								<br />- choisir le mode de retrait Click & Collect,
								<br />- valider sa Commande après avoir vérifié le récapitulatif de sa Commande,
								<br />- effectuer en ligne le paiement de sa Commande
								<br />- se rendre en Restaurant muni impérativement de son numéro de Commande envoyé par le Vendeur pour retirer sa
								Commande.
								<br /> Suite au paiement par le Client et à la validation de sa Commande, le Vendeur envoie au Client une confirmation
								de la Commande enregistrée sur le Site par courrier électronique avec un numéro de Commande. La fourniture en ligne du
								numéro de carte bancaire, la validation finale de la Commande et l'acceptation expresse par le Client des présentes
								CGV entrainent la reconnaissance d'en avoir parfaite connaissance et la renonciation à se prévaloir de ses propres
								conditions d'achat ou de toutes autres conditions. Le Client devra impérativement retirer en Restaurant sa Commande le
								jour même de sa validation sur le Site et avant l'heure de fermeture du Restaurant qu'il aura préalablement
								sélectionné ou de l'heure de fermeture du service de Click&Collect fixé par le Restaurant. Il appartient donc au
								Client de vérifier les heures de fermeture du Restaurant ou du service de Click&Collect. Les horaires du service de
								Click&Collect ainsi que les horaires d'ouverture du Restaurant où le Client souhaite retirer sa Commande sont
								disponibles sur le Site dans l'onglet informations. Il est précisé que la préparation de la Commande en Restaurant ne
								peut en aucune manière intervenir avant la présentation du Client en Restaurant pour retirer sa Commande.
							</p>
							<h3>Preuve de la Commande</h3>
							<p>
								La fourniture en ligne du numéro de carte bancaire et la validation finale de la Commande vaudront preuve de
								l'intégralité de ladite Commande et vaudront exigibilité des sommes engagées par la Commande. Le Vendeur procédera à
								l'archivage des bons de commandes et des factures sur un support fiable et durable, constituant une copie fidèle
								conformément aux dispositions de l'article 1360 du Code Civil. Les registres informatisés du Vendeur seront considérés
								par le Vendeur comme preuve des communications, des commandes, des paiements et des transactions intervenus entre les
								parties. En cas de désaccord il appartient au Client d’en apporter la preuve contraire.
							</p>
							<h3>Annulation et modification d'une Commande</h3>
							<p>
								Selon les dispositions de l’article L.221-28 4° du Code de la Consommation, le droit de rétractation applicable en
								matière de vente à distance ne peut être exercé dans le cas de la fourniture de biens qui du fait de leur nature sont
								susceptibles de se détériorer ou de se périmer rapidement. En application de ce texte, il est expressément indiqué que
								toute Commande sur le Site est ferme et définitive et que l'exercice du droit de rétractation est exclu. Les Commandes
								qui ont donc été définitivement validées, payées et retirées ne sont pas annulables. Aucune marchandise ne peut être
								reprise ou échangée.
							</p>
							<h3>Retraits des Produits</h3>
							<p>
								Le retrait des Produits dans le Restaurant ne peut se faire qu'à partir de l'heure d'ouverture du Restaurant que le
								Client a préalablement sélectionné et avant l'heure de fermeture dudit Restaurant ou l'heure de fermeture du service
								de Click & Collect fixé par le Restaurant sélectionné. Les horaires du service de Click & Collect ainsi que les
								horaires d'ouverture du Restaurant où le Client souhaite retirer sa Commande sont disponibles sur le Site au moment où
								le Client sélectionne ledit Restaurant. Le Client ne pourra retirer ses Produits dans le Restaurant qu'il aura
								préalablement sélectionné lors de sa Commande sur le Site qu’en se munissant de son numéro de Commande et du code
								barre figurant sur l'e-mail de confirmation de sa commande dans le cadre d’une commande avec les services Click &
								Collect. Le Vendeur remettra au Client un ticket de caisse. En cas de non retrait d'une Commande par le Client, passée
								avec le service Click&Collect, les produits commandés ne seront pas délivrés mais le prix de la Commande sera débité
								dès lors que le Client a lancé la préparation de sa commande.
							</p>
							<h3>Livraison des produits</h3>
							<p>
								La Livraison est assurée par le Livreur sélectionné par UberEats ou Deliveroo qui agit en son nom et sous sa seule
								responsabilité. 7.1. Frais de livraison Ces frais de livraison sont facturés par Uber-eats ou Deliveroo au nom et pour
								le compte du Livreur. 7.2. Délai de livraison Le Client est informé de la prise en charge de sa demande de Livraison
								et de l’évolution de celle-ci via UberEats ou Deliveroo. Le Livreur fait ses meilleurs efforts pour livrer les
								Produits au Client en moins de 30 minutes, sans engagement ferme de sa part compte tenu des aléas et des risques. Si
								la Commande n’est pas livrée dans les meilleurs délais, le Client a la possibilité de contacter le Livreur via
								UberEats ou Deliveroo. En cas d’impossibilité pour le Livreur d’effectuer la Livraison, le Client en est informé via
								UberEats ou Deliveroo. 7.3. Remise de la commande La remise de la commande au Client est de l’entière responsabilité
								du Livreur sélectionné par UberEats ou Deliveroo qui agit en son nom et sous sa seule responsabilité.
							</p>
							<h3>Réclamations</h3>
							<p>
								8.1. Réclamations en lien avec la livraison Toute question ou réclamation concernant la livraison devra être faite
								directement à UberEats ou Deliveroo. 8.2. Réclamation en lien avec les Produits Toute question ou réclamation
								concernant les Produits retirés en Restaurants devra être faite par courriel sur l’adresse suivante
								contact@thaibreak.fr ou sur les réseaux sociaux. Le Client devra indiquer le numéro de la commande pour le traitement
								de sa réclamation.
							</p>
							<h3>Prix</h3>
							<p>
								Les prix figurant sur la page de Commande du Site sont des prix TTC (toutes taxes comprises) en euro tenant compte de
								la TVA applicable au jour de la Commande. Le Vendeur se réserve le droit de modifier ses prix à tout moment, étant
								toutefois entendu que le prix figurant au catalogue le jour de la Commande sera le seul applicable.
							</p>
							<h3>Modalités de paiement de la Commande</h3>
							<p>
								Les Commandes effectuées sur le Site ne peuvent être effectuées qu'au moyen d'une carte bancaire. Le Vendeur garantit
								la préservation du caractère confidentiel des numéros de carte bancaire par des procédures de protection et de
								cryptologie.
							</p>
							<h3>Responsabilité</h3>
							<p>
								Le Vendeur, dans le processus de vente en ligne, n'est tenu que par une obligation de moyens. Le Vendeur ne peut être
								tenu pour responsable des dommages de toute nature tant matériels qu'immatériels qui pourraient résulter d'une
								mauvaise utilisation de l'identifiant ou du mode opératoire de passation de commande. La responsabilité du Vendeur ne
								pourra être engagée pour un risque inhérent à l'utilisation du réseau Internet tel que perte de données, intrusion,
								virus, rupture du service ou tout autre risque assimilé. Dans le cadre d'une Commande en Livraison, la Livraison est
								assurée par le Livreur en son nom et sous sa seule responsabilité. En conséquence la responsabilité du Vendeur ne
								pourra en aucun cas être engagée pour des dommages résultant du service de Livraison.
							</p>
							<h3>Protection des données personnelles</h3>
							<p>
								Les données personnelles collectées sur le Site sont soumises à la politique de protection des données personnelles de
								{restaurant.name}. Pour en savoir plus sur la protection des données personnelles.
							</p>
							<h3>Réglement des litiges et droit applicable</h3>
							<p>
								Les présentes CGV sont soumises à la loi française. En cas de litige, le litige sera soumis aux tribunaux français. En
								cas de litiges, le Client peut tout d'abord contacter le Vendeur afin de rechercher une solution amiable. Avant de la
								saisir, le Client doit écrire au restaurant concerné par courrier recommandé avec accusé de réception.
							</p>
						</div>
					</div>
				</div>
				<Footer
					footer={{
						style: 'ct-footer footer-dark',
						logo: 'assets/img/logo-light.png',
					}}
				/>
			</Fragment>
		)
	}
}

export default CGV
